import { request } from '~/agent';

export const getPath = (id, params) => {
    return request.get(`paths/${id}/contents`, params);
};

export const getFiles = params => {
    return request.get('files', params);
};

export const getFile = (id, params) => {
    return request.get(`files/${id}`, params);
};

export const uploadFile = (file, params, config) => {
    return request.upload('files', null, file, params, config);
};

export const downloadFiles = (fileID, params) => {
    return request.download(`files/${fileID}/download`, params);
};

export const downloadMultipleFiles = (data, params) => {
    return request.download(`files/download/multi`, params, data, 'POST');
};

export const searchFiles = (objectID, objectTypeID, params) => {
    return request.get(`files/attachments/${objectTypeID}/${objectID}`, params);
};

export const uploadImage = (file, params, config) => {
    return request.upload('files/images', null, file, params, config);
};

export const uploadPortfolioFile = (file, params, config) => {
    return request.upload('files/portfolio', null, file, params, config);
};

export const deleteFile = () => {
    return null;
};
